import axios from "axios";
import consts from "../consts";
import { reset as resetForm, initialize } from "redux-form";
import { setErroAPI, setError, setSuccess } from "../common/toast/toast";
import confirmDialog from "../common/dialog/confirmDialog";
import { adicionarBloqueioUsuarioImplantacao } from "../utils/adicionarBloqueioUsuarioImplantacao";
import { getUcValidarUsuarioImplantacao } from "../cliente/clienteActions";

export function setModoTela(modo, registro = {}) {
    return {
        type: "CONSUMO_INTEGRACAO_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "CONSUMO_INTEGRACAO_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function initForm(registro = {}) {
    return [initialize("consumoIntegracaoForm", registro)];
}

export function setFiltro(filtro) {
    return {
        type: "CONSUMO_INTEGRACAO_FILTRO",
        payload: filtro,
    };
}

const ID_ORIGEM_USINA_SOLAR = 1;

// Prepara os campos de leitura de tensão antes do POST/PUT.
// Fora de Usina Solar, descarta integração e inversor para não gravar seleção incompleta.
function normalizarLeituraTensao(registro) {
    const lerTensao = !!registro.ler_tensao;
    const idOrigem = lerTensao ? parseInt(registro.id_origem_dados_tensao, 10) || null : null;
    const usinaSolar = idOrigem === ID_ORIGEM_USINA_SOLAR;

    return {
        ler_tensao: lerTensao,
        id_origem_dados_tensao: idOrigem,
        id_geracao_integracao_tensao: usinaSolar ? registro.id_geracao_integracao_tensao || null : null,
        inversor_tensao: usinaSolar ? registro.inversor_tensao || null : null,
    };
}

// Validação da tela. Devolve a mensagem de erro ou null quando pode salvar.
function validarLeituraTensao(leitura) {
    if (!leitura.ler_tensao) return null;
    if (!leitura.id_origem_dados_tensao) return "Informe a origem dos dados de tensão";
    if (leitura.id_origem_dados_tensao !== ID_ORIGEM_USINA_SOLAR) return "A origem dos dados de tensão selecionada ainda não está disponível";
    if (!leitura.id_geracao_integracao_tensao) return "Informe a integração solar";
    if (!leitura.inversor_tensao) return "Informe o inversor";
    return null;
}

export function salvar(registro) {
    return (dispatch, getState) => {
        const leituraTensao = normalizarLeituraTensao(registro);
        const erroLeituraTensao = validarLeituraTensao(leituraTensao);
        if (erroLeituraTensao) {
            setError(erroLeituraTensao);
            return;
        }

        const registroFormatado = {
            ...registro,
            ...leituraTensao,
            constante_medidor: registro.id_consumo_integracao_tipo == 5 ? parseFloat(registro.constante_medidor.replace(",", ".")) || null : null,
        };

        if (!registro.id) {
            dispatch(setAguardando(true));
            axios
                .post(`${consts.API_URL}/consumoIntegracao`, registroFormatado)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getLista());
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                    dispatch(initForm(registro));
                })
                .finally(() => {
                    dispatch(setAguardando(false));
                });
        } else {
            confirmDialog("Deseja realmente alterar?", () => {
                dispatch(setAguardando(true));

                axios
                    .put(`${consts.API_URL}/consumoIntegracao`, registroFormatado)
                    .then((resp) => {
                        setSuccess("Operação Realizada com sucesso.");
                        dispatch(getLista());
                        dispatch(setModoTela("lista"));
                    })
                    .catch((e) => {
                        setErroAPI(e);
                        dispatch(initForm(registro));
                    })
                    .finally(() => {
                        dispatch(setAguardando(false));
                    });
            });
        }
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        confirmDialog("Deseja realmente excluir?", () => {
            axios
                .delete(`${consts.API_URL}/consumoIntegracao?id=${registro.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getLista());
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        });
    };
}

export function getLista() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            dispatch(setAguardando(true));
            await dispatch(getUcValidarUsuarioImplantacao());

            const idCliente = getState().consumoIntegracao.filtro.id_cliente || null;
            const idUc = getState().consumoIntegracao.filtro.id_unidade_consumidora || null;
            const resp = await axios.get(
                `${consts.API_URL}/consumoIntegracao?id_cliente=${idCliente}&id_unidade_consumidora=${idUc}&id_empresa=${idEmpresa}`
            );

            //busca lista de UC
            const { listaUcValidarUsuarioImplantacao } = getState().cliente;

            const listaFiltrada = adicionarBloqueioUsuarioImplantacao(usuarioLogado, listaUcValidarUsuarioImplantacao, resp.data);
            dispatch({
                type: "CONSUMO_INTEGRACAO_LISTADO",
                payload: { data: listaFiltrada },
            });
        } catch (e) {
            setError("Não foi possível carregar a lista de integrações");
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "CONSUMO_INTEGRACAO_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "CONSUMO_INTEGRACAO_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

// Busca as integrações solares da UC para os selects de integração e inversor.
// Ignora a resposta se a UC do formulário mudou antes da volta da requisição.
export function getListaGeracaoIntegracaoTensao(idUnidadeConsumidora) {
    return async (dispatch, getState) => {
        const idSolicitado = idUnidadeConsumidora;
        if (!idSolicitado) {
            dispatch({
                type: "CONSUMO_INTEGRACAO_GERACAO_TENSAO_LISTADO",
                payload: [],
            });
            return;
        }

        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;
            const resp = await axios.get(
                `${consts.API_URL}/geracaoIntegracao/listarPorUcSelect?id_unidade_consumidora=${idSolicitado}&id_empresa=${idEmpresa}`
            );
            const formulario = getState().form.consumoIntegracaoForm;
            const idAtual = formulario && formulario.values ? formulario.values.id_unidade_consumidora : null;
            if (String(idAtual) !== String(idSolicitado)) return;

            dispatch({
                type: "CONSUMO_INTEGRACAO_GERACAO_TENSAO_LISTADO",
                payload: resp.data || [],
            });
        } catch (e) {
            setErroAPI(e);
            dispatch({
                type: "CONSUMO_INTEGRACAO_GERACAO_TENSAO_LISTADO",
                payload: [],
            });
        }
    };
}

// Lista as origens de dados de tensão ativas para o select do formulário.
export function getListaOrigemDadosTensao() {
    const request = axios.get(`${consts.API_URL}/origemDadosTensao/listarSelect`);
    return {
        type: "CONSUMO_INTEGRACAO_ORIGEM_DADOS_TENSAO_LISTADO",
        payload: request,
    };
}

export function getListaConsumoIntegracaoTipos() {
    const request = axios.get(`${consts.API_URL}/consumoIntegracaoTipo/listarSelect`);
    return {
        type: "CONSUMO_INTEGRACAO_TIPOS_SELECT_LISTADO",
        payload: request,
    };
}
